export enum UnmountItemImageStatus {
    PENDING_UNMOUNTING = "Pending Unmounting",
    DONE = "With Image",
    WITHOUT_IMAGE = "Without Image",
}
